import ConnectionPage from "pages/ConnectionPage";
import { routesConfig } from "config/app-config";
import { createBrowserRouter } from "react-router";
import { BaseErrorPage } from "pages/errors";
import UnauthenticatedRootWithErrorBoundary from "components/Template/UnauthenticatedRoot";

const unAuthenticatedRouter = createBrowserRouter([
  {
    element: <UnauthenticatedRootWithErrorBoundary />,
    errorElement: <BaseErrorPage />,
    children: [
      {
        path: routesConfig.any.path,
        element: <ConnectionPage />,
      },
    ],
  },
]);

export default unAuthenticatedRouter;
